import * as $ from 'jquery';
import Swal from 'sweetalert2';

export default (function () {
    /**
     * We'll load the axios HTTP library which allows us to easily issue requests
     * to our Laravel back-end. This library automatically handles sending the
     * CSRF token as a header based on the value of the "XSRF" token cookie.
     */

    window.axios = require('axios');

    window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    
    /**
     * Next we will register the CSRF Token as a common header with Axios so that
     * all outgoing HTTP requests automatically have it attached. This is just
     * a simple convenience so we don't have to attach every token manually.
     */
    
    // let token = document.head.querySelector('meta[name="csrf-token"]');
    
    // if (token) {
    //     window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    // } else {
    //     console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
    // }

    // Add a request interceptor
    window.axios.interceptors.request.use(function (config) {
        // Do something before request is sent
        return config;
    }, function (error) {
        // Do something with request error
        return Promise.reject(error);
    });

    // Add a response interceptor
    window.axios.interceptors.response.use(function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger

        // Update all tooltips on page
        setTimeout(()=>{
            $('[data-toggle="tooltip"]').tooltip({ boundary: 'window' });
        }, 1000);

        // Do something with response data
        return response;

    }, function (error) {
        if (error.response == undefined) {
            console.log('Atenção: Verifique se a URL chamada está correta...');
            console.log(error);
            return;
        }
        
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        if (error.response.status == 422) {
            Swal.fire({
                title: 'Atenção!',
                text: error.response.data.errors[Object.keys(error.response.data.errors)[0]],
                type: 'error',
            });
        } else if (error.response.status == 412) {
            Swal.fire({
                title: 'Ops!',
                html: error.response.data.message,
                showCancelButton: true,
                type: 'warning',
            }).then(res => {
                if (res.value) {
                    window.location.href = error.response.data.redirect;
                }
            });
        } else if (error.response.status == 401) {
            window.location.reload();
        } else {
            Swal.fire({
                title: 'Ops...',
                text: 'Ocorreu um erro desconhecido, entre em contato com nosso suporte.',
                type: 'error',
            });
        }
        // Do something with response error
        return Promise.reject(error);
    });
}());
